<div class="date-picker-container">
  <svg-icon src="assets/icons/calendar.svg" [svgStyle]="{ 'width.px': 21 }"></svg-icon>

  <div class="date-picker date-picker--from">
    <svg-icon
      class="arrow"
      [ngClass]="{ 'arrow--disabled': arrowDisabled('from', slideDirections.PREV) }"
      src="assets/icons/chevron-down.svg"
      [svgStyle]="{ 'height.px': 15, 'transform': 'rotate(90deg)' }"
      (click)="prevMonth('from')"
      (keydown.space)="!arrowDisabled('from', slideDirections.PREV) && prevMonth('from')"
      (keydown.enter)="!arrowDisabled('from', slideDirections.PREV) && prevMonth('from')"
      tabindex="0"
    ></svg-icon>

    <div class="date">
      {{ fromControl.value | date:'M / y' }}
    </div>

    <svg-icon
      class="arrow"
      [ngClass]="{ 'arrow--disabled': arrowDisabled('from', slideDirections.NEXT) }"
      src="assets/icons/chevron-down.svg"
      [svgStyle]="{ 'height.px': 15, 'transform': 'rotate(270deg)' }"
      (click)="nextMonth('from')"
      data-cy="datepicker-from-next-button"
      (keydown.space)="!arrowDisabled('from', slideDirections.NEXT) && nextMonth('from')"
      (keydown.enter)="!arrowDisabled('from', slideDirections.NEXT) && nextMonth('from')"
      tabindex="0"
    ></svg-icon>
  </div>

  <div class="vertical-divider"></div>

  <div class="date-picker date-picker--to">
    <svg-icon
      class="arrow"
      [ngClass]="{ 'arrow--disabled': arrowDisabled('to', slideDirections.PREV) }"
      src="assets/icons/chevron-down.svg"
      [svgStyle]="{ 'height.px': 15, 'transform': 'rotate(90deg)' }"
      (click)="prevMonth('to')"
      data-cy="datepicker-to-prev-button"
      (keydown.space)="!arrowDisabled('to', slideDirections.PREV) && prevMonth('to')"
      (keydown.enter)="!arrowDisabled('to', slideDirections.PREV) && prevMonth('to')"
      tabindex="0"
    ></svg-icon>

    <div class="date" data-cy="datepicker-to-selected-date">
      {{ toControl.value | date:'M / y' }}
    </div>

    <svg-icon class="arrow"
      [ngClass]="{ 'arrow--disabled': arrowDisabled('to', slideDirections.NEXT) }"
      src="assets/icons/chevron-down.svg"
      [svgStyle]="{ 'height.px': 15, 'transform': 'rotate(270deg)' }"
      (click)="nextMonth('to')"
      (keydown.space)="!arrowDisabled('to', slideDirections.NEXT) && nextMonth('to')"
      (keydown.enter)="!arrowDisabled('to', slideDirections.NEXT) && nextMonth('to')"
      tabindex="0"
    ></svg-icon>
  </div>
</div>